import OptionalInputLabel from "./OptionalInputLabel";

export default OptionalInputLabel;
